import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="oif-warning"
export default class extends Controller {
  static targets = ["attendedField", "modal"]
  static values = {
    hasLinkage: Boolean,
    originalValue: String
  }

  connect() {
    // Store the initial value when the form loads
    this.originalValueValue = this.attendedFieldTarget.value
  }

  disconnect() {
    // Cleanup: Remove any orphaned backdrops when controller is disconnected
    if (this.backdrop && this.backdrop.parentNode) {
      this.backdrop.parentNode.removeChild(this.backdrop)
      document.body.classList.remove('modal-open')
    }
  }

  // Called when the attended_oif_course field changes
  checkChange(event) {
    const newValue = event.target.value
    const oldValue = this.originalValueValue

    if (newValue === "no" || newValue === "no_information") {
      this.hideOifLevelFormGroup()
    }

    if (newValue === "yes") {
      this.showOifLevelFormGroup()
    }

    // FR-014: Show warning if changing from "yes" to "no"/"no_information" AND linkage exists
    if (oldValue === "yes" && (newValue === "no" || newValue === "no_information") && this.hasLinkageValue) {
      // Prevent the form from submitting
      event.preventDefault()

      // Show the warning modal using vanilla JavaScript
      this.showModal()

      // Store the new value temporarily
      this.pendingValue = newValue

      // Revert the field to the original value until user confirms
      this.attendedFieldTarget.value = oldValue
    } else {
      // FR-017: Allow changes without warning if no linkage exists
      this.originalValueValue = newValue
    }
  }

  // Called when user clicks "Bestätigen" (confirm) button
  confirm() {
    // Update the original value to the new value
    this.originalValueValue = this.pendingValue

    // Set the field to the new value
    this.attendedFieldTarget.value = this.pendingValue

    // Close the modal
    this.hideModal()

    // The form can now be submitted normally
    // The backend callback will handle the unlinking (FR-016)
  }

  // Called when user clicks "Abbrechen" (cancel) button
  cancel() {
    // Keep the original value (field is already set to original value)
    // Just close the modal
    this.hideModal()

    // Clear the pending value
    this.pendingValue = null
  }

  // Show modal using vanilla JavaScript (Bootstrap 4 compatible)
  showModal() {
    try {
      const modal = this.modalTarget

      // Create and configure backdrop
      if (!this.backdrop) {
        this.backdrop = document.createElement("div")
        this.backdrop.classList.add("modal-backdrop", "fade")
      }

      // Update body and DOM
      document.body.classList.add("modal-open")
      document.body.appendChild(this.backdrop)

      // Show modal with proper attributes
      modal.style.display = "block"
      modal.setAttribute("aria-hidden", "false")
      modal.setAttribute("aria-modal", "true")

      // Trigger CSS transitions
      requestAnimationFrame(() => {
        modal.classList.add("show")
        this.backdrop.classList.add("show")
      })

      this.hideOifLevelFormGroup()
    } catch (error) {
      console.error("Error showing OIF warning modal:", error)
    }
  }

  // hide the OIF level form group
  hideOifLevelFormGroup() {
    const oifLevelGroup = document.getElementById("oif-level-form-group")
    if (oifLevelGroup) {
      oifLevelGroup.style.display = "none"
    }
  }

  // show the OIF level form group
  showOifLevelFormGroup() {
    const oifLevelGroup = document.getElementById("oif-level-form-group")
    if (oifLevelGroup) {
      oifLevelGroup.style.display = ""
    }
  }

  // Hide modal using vanilla JavaScript (Bootstrap 4 compatible)
  hideModal() {
    try {
      const modal = this.modalTarget

      // Update ARIA
      modal.setAttribute("aria-hidden", "true")
      modal.removeAttribute("aria-modal")

      // Remove show classes (triggers CSS transition)
      if (this.backdrop) {
        this.backdrop.classList.remove("show")
      }
      modal.classList.remove("show")

      this.showOifLevelFormGroup()

      // Wait for CSS transition (Bootstrap default: 300ms)
      setTimeout(() => {
        modal.style.display = "none"
        if (this.backdrop && this.backdrop.parentNode) {
          this.backdrop.parentNode.removeChild(this.backdrop)
        }
        document.body.classList.remove("modal-open")
      }, 300)
    } catch (error) {
      console.error("Error hiding OIF warning modal:", error)
    }
  }
}
